import { graphqlClient, TGraphQLSubscriptions } from '../graphql-api-client/graphql-api-client';
import * as subscriptions from '../../graphql/subscriptions';
import * as mutations from '../../graphql/mutations';
import { CommandsInput, PublishSegmentsInput } from '../../graphql/API';
import { GraphQLResult } from '@aws-amplify/api';
import { protectedContentApiClient } from '../api-fetcher/api-client';
import {
  CuePoint,
  Presentation,
} from '../../store/presenter-slide-management-store/presentation-config-aggregate/presentation-config-aggregate-types/presentation-config-aggregate-types';
import { IPollSlideGenerateResponse } from './polls-dao';
import { LiveStreamStatus } from '../../constans/presenter-enums';

type TSubscription<T> = (
    presentationId: string | null,
    doneCallback: (data: T) => void,
    retrySubscriptionFn: () => TGraphQLSubscriptions
) => TGraphQLSubscriptions;

export interface ILivePresentationRestoredData {
    approximate_backup_streaming_time: number;
    approximate_live_event_time: number;
    approximate_streaming_time: number;
    backup_stream: boolean;
    create_backup: boolean;
    cuepoint: CuePoint;
    media: null;
    zoom: null | number;
}

export interface ILivePresentationInfo {
    countdown_date_time: null | string;
    description: string;
    ended_message: null | string;
    id: number;
    intermission_message: null | string;
    is_mirror: boolean;
    is_visited: boolean;
    live_status: LiveStreamStatus;
    logo_url: null | string;
    name: string;
    presentation_url: string;
    restored_data: ILivePresentationRestoredData;
    stand_by_message: string;
}

export interface ICommandObject {
    backup_stream?: boolean | null;
    backup_stream_time?: number | null;
    content?: string | null;
    stream_time?: number | null;
    type?: string | null;
    concurrencyUserId: string | null;
    currentSlideIndex: number;
    presentationId?: string | null;
    userName: string | null;
}

export enum SlidesCommand {
    REORDER = 'REORDER',
    REMOVE = 'REMOVE',
    ADD = 'ADD',
    UPDATE = 'UPDATE',
    PURGE = 'PURGE',
}

export interface ISlideCommandObject {
    action: SlidesCommand;
    atIndex: null | number;
    segments: string;
}

interface IOnChangeSlideSubscriptionResponse {
    onChangeSlides: ICommandObject;
}

interface IOnPublishSegmentsSubscriptionResponse {
    onPublishSegments: ISlideCommandObject;
}

export interface ISegmentOptions {
  smallThumbnail: string;
  largeThumbnail: string;
  assetId: number;
}

export const changeSlideCommandSubscriptionApi: TSubscription<IOnChangeSlideSubscriptionResponse> = (
  presentationId,
  doneCallback,
  retrySubscriptionFn
): TGraphQLSubscriptions => {
  return graphqlClient.subscriptions({
    query: subscriptions.onChangeSlides,
    variables: {
      presentationId: presentationId
    }}, doneCallback, retrySubscriptionFn);
};

export const updateSlideDeckSubscriptionApi: TSubscription<IOnPublishSegmentsSubscriptionResponse> = (
  presentationId,
  doneCallback,
  retrySubscriptionFn
): TGraphQLSubscriptions => {
  return graphqlClient.subscriptions({
    query: subscriptions.onPublishSegments,
    variables: {
      presentationId: presentationId
    }}, doneCallback, retrySubscriptionFn);
};

export const changeSlideMutationsApi = async (body: CommandsInput): Promise<GraphQLResult<{ commandsMutation: ICommandObject }>> => {
  return graphqlClient.operation({
    query: mutations.commandsMutation,
    variables: {
      input: {
        ...body
      }
    }
  });
};

export const getLivePresentationInfoApi = async (presentationId: string): Promise<ILivePresentationInfo> => {
  return protectedContentApiClient.get<ILivePresentationInfo>('live-presentations', {
    presentation_id: presentationId,
  });
};

export const getPresentationSlidesApi = async (presentationId: string): Promise<Presentation> => {
  return protectedContentApiClient.get<Presentation>(`presentations/${presentationId}/presenter/config`);
};

export const getAssetInfo = async (assetId: number): Promise<IPollSlideGenerateResponse> => {
  return protectedContentApiClient.get(`slides/${assetId}?url_format=s3_host_bucket`);
};

export const publishSegmentsMutation = async (body: PublishSegmentsInput, presentationId: string): Promise<GraphQLResult> => {
  return graphqlClient.operation({
    query: mutations.publishSegmentsPresenter,
    variables: {
      input: {
        ...body
      },
      presentationId: presentationId
    }
  });
};